import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-device-current-state',
  templateUrl: './device-current-state.component.html',
  styleUrls: ['./device-current-state.component.scss']
})
export class DeviceCurrentStateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
